module.exports = "<p *ngIf=\"data?.data?.data\">\n  {{data?.data?.data?.balance}}\n</p>\n<p *ngIf=\"data?.data?.error\">\n  0\n</p>\n"